import { literal } from "lit-html/static.js";
const tagMap = {
  h1: literal`h1`,
  h2: literal`h2`,
  h3: literal`h3`,
  h4: literal`h4`,
  h5: literal`h5`,
  h6: literal`h6`,
  p: literal`p`,
  span: literal`span`
};
const fontMap = {
  "jumbo-semibold": "dsf-text-jumbo-semibold",
  "xxl-semibold": "dsf-text-xxl-semibold",
  "xl-semibold": "dsf-text-xl-semibold",
  xs: "dsf-text-xs",
  "xs-semibold": "dsf-text-xs-semibold",
  xxs: "dsf-text-xxs",
  "xxs-semibold": "dsf-text-xxs-semibold",
  "s-semibold": "dsf-text-s-semibold",
  s: "dsf-text-s",
  "m-semibold": "dsf-text-m-semibold",
  "s-medium": "dsf-text-s-medium",
  "l-semibold": "dsf-text-l-semibold"
};
const textColorMap = {
  error_100: "text-error-100",
  error_200: "text-error-200",
  error_300: "text-error-300",
  error_400: "text-error-400",
  error_500: "text-error-500",
  error_50: "text-error-50",
  error_600: "text-error-600",
  neutral_0: "text-neutral-0",
  neutral_100: "text-neutral-100",
  neutral_200: "text-neutral-200",
  neutral_300: "text-neutral-300",
  neutral_400: "text-neutral-400",
  neutral_500: "text-neutral-500",
  neutral_50: "text-neutral-50",
  neutral_600: "text-neutral-600",
  neutral_700: "text-neutral-700",
  primary_100: "text-primary-100",
  primary_200: "text-primary-200",
  primary_300: "text-primary-300",
  primary_400: "text-primary-400",
  primary_500: "text-primary-500",
  primary_50: "text-primary-50",
  primary_600: "text-primary-600",
  secondary_100: "text-secondary-100",
  secondary_200: "text-secondary-200",
  secondary_300: "text-secondary-300",
  secondary_400: "text-secondary-400",
  secondary_500: "text-secondary-500",
  secondary_50: "text-secondary-50",
  secondary_600: "text-secondary-600",
  success_100: "text-success-100",
  success_200: "text-success-200",
  success_300: "text-success-300",
  success_400: "text-success-400",
  success_500: "text-success-500",
  success_50: "text-success-50",
  success_600: "text-success-600",
  warning_100: "text-warning-100",
  warning_200: "text-warning-200",
  warning_300: "text-warning-300",
  warning_400: "text-warning-400",
  warning_500: "text-warning-500",
  warning_50: "text-warning-50",
  warning_600: "text-warning-600"
};
const textDecorationMap = {
  error_100: "decoration-error-100",
  error_200: "decoration-error-200",
  error_300: "decoration-error-300",
  error_400: "decoration-error-400",
  error_500: "decoration-error-500",
  error_50: "decoration-error-50",
  error_600: "decoration-error-600",
  neutral_0: "decoration-neutral-0",
  neutral_100: "decoration-neutral-100",
  neutral_200: "decoration-neutral-200",
  neutral_300: "decoration-neutral-300",
  neutral_400: "decoration-neutral-400",
  neutral_500: "decoration-neutral-500",
  neutral_50: "decoration-neutral-50",
  neutral_600: "decoration-neutral-600",
  neutral_700: "decoration-neutral-700",
  primary_100: "decoration-primary-100",
  primary_200: "decoration-primary-200",
  primary_300: "decoration-primary-300",
  primary_400: "decoration-primary-400",
  primary_500: "decoration-primary-500",
  primary_50: "decoration-primary-50",
  primary_600: "decoration-primary-600",
  secondary_100: "decoration-secondary-100",
  secondary_200: "decoration-secondary-200",
  secondary_300: "decoration-secondary-300",
  secondary_400: "decoration-secondary-400",
  secondary_500: "decoration-secondary-500",
  secondary_50: "decoration-secondary-50",
  secondary_600: "decoration-secondary-600",
  success_100: "decoration-success-100",
  success_200: "decoration-success-200",
  success_300: "decoration-success-300",
  success_400: "decoration-success-400",
  success_500: "decoration-success-500",
  success_50: "decoration-success-50",
  success_600: "decoration-success-600",
  warning_100: "decoration-warning-100",
  warning_200: "decoration-warning-200",
  warning_300: "decoration-warning-300",
  warning_400: "decoration-warning-400",
  warning_500: "decoration-warning-500",
  warning_50: "decoration-warning-50",
  warning_600: "decoration-warning-600"
};
export {
  fontMap,
  tagMap,
  textColorMap,
  textDecorationMap
};
